import { styled } from '@mui/material';
import { ReactComponent as IconUser } from '../../../assets/images/user.svg';

export const StyledIconUser = styled(IconUser)(() => ({
  cursor: 'pointer',
  height: '24px',
  width: '24px',
}));
